var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-toolbar",
    [
      _c(
        "w-toolbar-select",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.$wf.isSmDown,
              expression: "!$wf.isSmDown",
            },
          ],
          staticClass: "user-select",
          attrs: { items: _vm.options },
          on: {
            click: function ($event) {
              return _vm.selectClicked($event)
            },
          },
        },
        [
          _c("div", { staticClass: "profile-wrap" }, [
            _vm.profileImgUrl
              ? _c("span", { staticClass: "profile" }, [
                  _c("img", {
                    staticClass: "profile-img",
                    attrs: { src: _vm.profileImgUrl, alt: "Profile image" },
                  }),
                ])
              : _vm._e(),
            _c("span", [
              _c("span", { staticClass: "company" }, [
                _vm._v(_vm._s(_vm.currentDossier)),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.wfUser.Firstname) +
                    " " +
                    _vm._s(_vm.wfUser.Lastname)
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm.$wf.isSmDown && !_vm.drawerButtonDisabled
        ? _c(
            "app-toolbar-button",
            {
              staticClass: "drawer-btn",
              on: {
                click: function ($event) {
                  return _vm.toggleDrawer()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "bars" } })],
            1
          )
        : _vm._e(),
      _vm._t("title", function () {
        return [
          _c("w-toolbar-text", { staticClass: "app-title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
        ]
      }),
      _c("w-spacer"),
      _vm._t("default"),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.changeDossierModal,
            callback: function ($$v) {
              _vm.changeDossierModal = $$v
            },
            expression: "changeDossierModal",
          },
        },
        [
          _c("app-select-dossier", {
            on: {
              close: function ($event) {
                _vm.changeDossierModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }